import React from 'react';
import { Link } from 'react-router-dom';
import { PRODUCTS, COLORS } from '../../data/siteData';
import { ArrowRight } from 'lucide-react';

const ProductsSection = () => {
  return (
    <section id="products" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold mb-4" style={{ color: COLORS.dark }}>
            {PRODUCTS.title}
          </h2>
          <p className="text-lg" style={{ color: COLORS.gray }}>
            {PRODUCTS.subtitle}
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {PRODUCTS.items.map((product, index) => (
            <div 
              key={index}
              className="group bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 border border-gray-100"
            >
              <div className="aspect-[4/3] overflow-hidden bg-gray-50 flex items-center justify-center p-4">
                <img
                  src={product.image}
                  alt={product.alt || product.title}
                  className="max-w-full max-h-full object-contain group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
              </div>
              <div className="p-6">
                <h3 className="text-lg font-semibold mb-2" style={{ color: COLORS.dark }}>
                  {product.title}
                </h3>
                <p className="text-sm" style={{ color: COLORS.gray }}>
                  {product.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Internal Link to Solutions Page */}
        <div className="text-center mt-12">
          <Link
            to="/sprendimai-bibliotekoms"
            className="inline-flex items-center gap-2 text-base font-medium transition-colors hover:opacity-80"
            style={{ color: COLORS.green }}
          >
            {PRODUCTS.seeAllSolutions}
            <ArrowRight className="w-5 h-5" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ProductsSection;
